export const MAX_MODARATED_PRODUCTS = 100;
